"use client";

import { c as _c } from "react/compiler-runtime";
import { initMfaEnrollmentWithSms } from "@opensea/embedded-wallet-sdk";
import { CenterAligned, classNames, Flex, FlexColumn, FormControl, List, ListItem, ListItemAvatar, ListItemContent, ListItemDescription, ListItemSide, ListItemTitle, PhoneInput, Spinner, TextBody, TextDisplay, Tooltip, UnstyledButton } from "@opensea/ui-kit";
import { ArrowForward, Check, PhoneAndroid, VerifiedUser } from "@opensea/ui-kit/icons";
import { QRCodeSVG } from "qrcode.react";
import { useEffect, useState } from "react";
import { useTranslations } from "use-intl";
import { useSnapshot } from "valtio";
import { AuthCode } from "../../../components/AuthCode";
import { Button } from "../../../components/Button";
import { ContentCopy } from "../../../components/icons/ContentCopy";
import { ModalBackButton } from "../../../components/Modal";
import { PasteFromClipboardButton } from "../../../components/PasteFromClipboardButton";
import { ResendCode } from "../../../components/ResendCode";
import { MfaEnrollmentActions, MfaEnrollmentState } from "../../../stores/mfaEnrollmentStore";
import { useMfaMethods } from "../../use-mfa-methods";
const CODE_EXPIRATION_MS = 10 * 60 * 1000;
const SelectEnrollmentOption = t0 => {
  const $ = _c(79);
  const {
    enrolledMfaMethods
  } = t0;
  const t = useTranslations("wallet.MfaEnrollment");
  const {
    initializingStep
  } = useSnapshot(MfaEnrollmentState);
  let t1;
  if ($[0] !== t) {
    t1 = t("activateMultiFactorTitle");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <TextDisplay size="sm">{t1}</TextDisplay>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t) {
    t3 = t("activateMultiFactorDescription");
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = <TextBody color="text-secondary" size="sm">{t3}</TextBody>;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t2 || $[9] !== t4) {
    t5 = <FlexColumn className="gap-4">{t2}{t4}</FlexColumn>;
    $[8] = t2;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t) {
    t6 = t("alreadyEnrolled");
    $[11] = t;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const t7 = !enrolledMfaMethods.includes("sms");
  let t8;
  if ($[13] !== enrolledMfaMethods) {
    t8 = enrolledMfaMethods.includes("sms");
    $[13] = enrolledMfaMethods;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <ListItemAvatar icon={PhoneAndroid} />;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t) {
    t10 = t("sms");
    $[16] = t;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10) {
    t11 = <ListItemTitle>{t10}</ListItemTitle>;
    $[18] = t10;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t) {
    t12 = t("smsDescription");
    $[20] = t;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <br />;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== t) {
    t14 = t("smsRegionRestriction");
    $[23] = t;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== t12 || $[26] !== t14) {
    t15 = <ListItemDescription className="text-start">{t12}{t13}{t14}</ListItemDescription>;
    $[25] = t12;
    $[26] = t14;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  let t16;
  if ($[28] !== t11 || $[29] !== t15) {
    t16 = <ListItemContent>{t11}{t15}</ListItemContent>;
    $[28] = t11;
    $[29] = t15;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  let t17;
  if ($[31] !== initializingStep) {
    t17 = initializingStep === "enroll-sms" && <Spinner />;
    $[31] = initializingStep;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  let t18;
  if ($[33] !== t16 || $[34] !== t17 || $[35] !== t8) {
    t18 = <div><ListItem disabled={t8} onClick={_temp}>{t9}{t16}{t17}</ListItem></div>;
    $[33] = t16;
    $[34] = t17;
    $[35] = t8;
    $[36] = t18;
  } else {
    t18 = $[36];
  }
  let t19;
  if ($[37] !== t18 || $[38] !== t6 || $[39] !== t7) {
    t19 = <Tooltip content={t6} disabled={t7}>{t18}</Tooltip>;
    $[37] = t18;
    $[38] = t6;
    $[39] = t7;
    $[40] = t19;
  } else {
    t19 = $[40];
  }
  let t20;
  if ($[41] !== t) {
    t20 = t("alreadyEnrolled");
    $[41] = t;
    $[42] = t20;
  } else {
    t20 = $[42];
  }
  const t21 = !enrolledMfaMethods.includes("totp");
  let t22;
  if ($[43] !== enrolledMfaMethods) {
    t22 = enrolledMfaMethods.includes("totp");
    $[43] = enrolledMfaMethods;
    $[44] = t22;
  } else {
    t22 = $[44];
  }
  let t23;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <ListItemAvatar icon={VerifiedUser} />;
    $[45] = t23;
  } else {
    t23 = $[45];
  }
  let t24;
  if ($[46] !== t) {
    t24 = t("authenticator");
    $[46] = t;
    $[47] = t24;
  } else {
    t24 = $[47];
  }
  let t25;
  if ($[48] !== t24) {
    t25 = <ListItemTitle>{t24}</ListItemTitle>;
    $[48] = t24;
    $[49] = t25;
  } else {
    t25 = $[49];
  }
  let t26;
  if ($[50] !== t) {
    t26 = t("authenticatorDescription");
    $[50] = t;
    $[51] = t26;
  } else {
    t26 = $[51];
  }
  let t27;
  if ($[52] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = <br />;
    $[52] = t27;
  } else {
    t27 = $[52];
  }
  let t28;
  if ($[53] !== t) {
    t28 = t("authenticatorSecurityNote");
    $[53] = t;
    $[54] = t28;
  } else {
    t28 = $[54];
  }
  let t29;
  if ($[55] !== t26 || $[56] !== t28) {
    t29 = <ListItemDescription className="text-start">{t26}{t27}{t28}</ListItemDescription>;
    $[55] = t26;
    $[56] = t28;
    $[57] = t29;
  } else {
    t29 = $[57];
  }
  let t30;
  if ($[58] !== t25 || $[59] !== t29) {
    t30 = <ListItemContent>{t25}{t29}</ListItemContent>;
    $[58] = t25;
    $[59] = t29;
    $[60] = t30;
  } else {
    t30 = $[60];
  }
  let t31;
  if ($[61] !== initializingStep) {
    t31 = initializingStep === "enroll-totp" && <Spinner />;
    $[61] = initializingStep;
    $[62] = t31;
  } else {
    t31 = $[62];
  }
  let t32;
  if ($[63] !== t31) {
    t32 = <ListItemSide>{t31}</ListItemSide>;
    $[63] = t31;
    $[64] = t32;
  } else {
    t32 = $[64];
  }
  let t33;
  if ($[65] !== t22 || $[66] !== t30 || $[67] !== t32) {
    t33 = <div><ListItem disabled={t22} onClick={_temp2}>{t23}{t30}{t32}</ListItem></div>;
    $[65] = t22;
    $[66] = t30;
    $[67] = t32;
    $[68] = t33;
  } else {
    t33 = $[68];
  }
  let t34;
  if ($[69] !== t20 || $[70] !== t21 || $[71] !== t33) {
    t34 = <Tooltip content={t20} disabled={t21}>{t33}</Tooltip>;
    $[69] = t20;
    $[70] = t21;
    $[71] = t33;
    $[72] = t34;
  } else {
    t34 = $[72];
  }
  let t35;
  if ($[73] !== t19 || $[74] !== t34) {
    t35 = <List>{t19}{t34}</List>;
    $[73] = t19;
    $[74] = t34;
    $[75] = t35;
  } else {
    t35 = $[75];
  }
  let t36;
  if ($[76] !== t35 || $[77] !== t5) {
    t36 = <FlexColumn className="gap-8 pt-12 pb-6">{t5}{t35}</FlexColumn>;
    $[76] = t35;
    $[77] = t5;
    $[78] = t36;
  } else {
    t36 = $[78];
  }
  return t36;
};
export const EnrollSms = () => {
  const $ = _c(60);
  const t = useTranslations("wallet.MfaEnrollment");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [intializing, setInitializing] = useState(false);
  const [isInitialized, setIsInitialized] = useState(false);
  const [code, setCode] = useState("");
  const {
    submissionError
  } = useSnapshot(MfaEnrollmentState);
  let t0;
  if ($[0] !== isInitialized) {
    t0 = isInitialized ? () => setIsInitialized(false) : MfaEnrollmentActions.onBack;
    $[0] = isInitialized;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const onBack = t0;
  let t1;
  if ($[2] !== phoneNumber) {
    t1 = async () => {
      setInitializing(true);
      await initMfaEnrollmentWithSms(phoneNumber);
      setIsInitialized(true);
      setInitializing(false);
    };
    $[2] = phoneNumber;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const onSendCode = t1;
  const [codeExpired, setCodeExpired] = useState(false);
  const [lastSendTime, setLastSendTime] = useState(_temp3);
  let t2;
  if ($[4] !== onSendCode) {
    t2 = async () => {
      await onSendCode();
      setLastSendTime(new Date());
      MfaEnrollmentActions.setSubmissionError(undefined);
      setCode("");
    };
    $[4] = onSendCode;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const resendCode = t2;
  let t3;
  if ($[6] !== code) {
    t3 = [code];
    $[6] = code;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  useEffect(_temp4, t3);
  let t4;
  if ($[8] !== phoneNumber) {
    t4 = async currentCode => {
      setCode(currentCode);
      await MfaEnrollmentActions.submitEnrollment({
        code: currentCode,
        phoneNumber
      });
    };
    $[8] = phoneNumber;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const onSubmit = t4;
  let t5;
  if ($[10] !== isInitialized || $[11] !== t) {
    t5 = isInitialized ? t("enterCode") : t("enterPhoneNumber");
    $[10] = isInitialized;
    $[11] = t;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t5) {
    t6 = <TextDisplay className="leading-[28px]" size="sm">{t5}</TextDisplay>;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== isInitialized || $[16] !== t) {
    t7 = isInitialized ? t("codeSentViaSMS") : t("codeWillBeSentViaSMS");
    $[15] = isInitialized;
    $[16] = t;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t7) {
    t8 = <TextBody className="text-center" color="text-secondary" size="sm">{t7}</TextBody>;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t6 || $[21] !== t8) {
    t9 = <FlexColumn className="gap-4">{t6}{t8}</FlexColumn>;
    $[20] = t6;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = classNames("h-14 bg-bg-primary *:bg-bg-primary");
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  const t11 = isInitialized || intializing;
  let t12;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = classNames("h-full overflow-hidden");
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== intializing) {
    t13 = intializing ? <CenterAligned className="size-5"><Spinner color="white" size="xs" /></CenterAligned> : ArrowForward;
    $[25] = intializing;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== t13) {
    t14 = {
      Input: {
        className: t12,
        endEnhancer: <Button className="h-8 rounded-lg p-1.5" icon={t13} size="sm" type="submit" />
      }
    };
    $[27] = t13;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== onSendCode || $[30] !== phoneNumber || $[31] !== t11 || $[32] !== t14) {
    t15 = <PhoneInput className={t10} disabled={t11} onEnter={onSendCode} onValueChange={setPhoneNumber} overrides={t14} value={phoneNumber} />;
    $[29] = onSendCode;
    $[30] = phoneNumber;
    $[31] = t11;
    $[32] = t14;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== isInitialized || $[35] !== t) {
    t16 = isInitialized && <TextBody className="text-center" color="text-secondary" size="sm">{t("checkPhoneForCode")}</TextBody>;
    $[34] = isInitialized;
    $[35] = t;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] !== t15 || $[38] !== t16) {
    t17 = <CenterAligned className="gap-4">{t15}{t16}</CenterAligned>;
    $[37] = t15;
    $[38] = t16;
    $[39] = t17;
  } else {
    t17 = $[39];
  }
  let t18;
  if ($[40] !== code || $[41] !== codeExpired || $[42] !== intializing || $[43] !== isInitialized || $[44] !== lastSendTime || $[45] !== onSendCode || $[46] !== onSubmit || $[47] !== resendCode || $[48] !== submissionError || $[49] !== t) {
    t18 = isInitialized ? <><FormControl error={submissionError} hideLabel={true} label={t("authenticationCodeLabel")} overrides={{
        Caption: {
          className: "justify-center"
        }
      }}><AuthCode autoFocus={true} error={codeExpired || !!submissionError} onChange={setCode} onComplete={onSubmit} value={code} /></FormControl><div><PasteFromClipboardButton className="mt-8 md:hidden" onPaste={onSubmit} /><ResendCode codeExpiration={lastSendTime.getTime() + CODE_EXPIRATION_MS} sendCode={resendCode} setCodeExpired={setCodeExpired} /></div></> : <CenterAligned className="gap-4"><Button className="w-full" disabled={intializing} isLoading={intializing} onClick={onSendCode} size="lg">{t("sendCode")}</Button></CenterAligned>;
    $[40] = code;
    $[41] = codeExpired;
    $[42] = intializing;
    $[43] = isInitialized;
    $[44] = lastSendTime;
    $[45] = onSendCode;
    $[46] = onSubmit;
    $[47] = resendCode;
    $[48] = submissionError;
    $[49] = t;
    $[50] = t18;
  } else {
    t18 = $[50];
  }
  let t19;
  if ($[51] !== t17 || $[52] !== t18 || $[53] !== t9) {
    t19 = <FlexColumn className="gap-8 pt-12 pb-6">{t9}{t17}{t18}</FlexColumn>;
    $[51] = t17;
    $[52] = t18;
    $[53] = t9;
    $[54] = t19;
  } else {
    t19 = $[54];
  }
  let t20;
  if ($[55] !== onBack) {
    t20 = <ModalBackButton onBack={onBack} />;
    $[55] = onBack;
    $[56] = t20;
  } else {
    t20 = $[56];
  }
  let t21;
  if ($[57] !== t19 || $[58] !== t20) {
    t21 = <>{t19}{t20}</>;
    $[57] = t19;
    $[58] = t20;
    $[59] = t21;
  } else {
    t21 = $[59];
  }
  return t21;
};
export const EnrollTotp = t0 => {
  const $ = _c(42);
  const {
    authUrl,
    secret
  } = t0;
  const t = useTranslations("wallet.MfaEnrollment");
  const [code, setCode] = useState("");
  const [copied, setCopied] = useState(false);
  let t1;
  if ($[0] !== secret) {
    t1 = async () => {
      setCopied(true);
      await navigator.clipboard.writeText(secret);
      setTimeout(() => setCopied(false), 2000);
    };
    $[0] = secret;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const onCopy = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = async currentCode => {
      setCode(currentCode);
      await MfaEnrollmentActions.submitEnrollment({
        code: currentCode
      });
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const onSubmit = t2;
  let t3;
  if ($[3] !== t) {
    t3 = t("scanQrCode");
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <TextDisplay className="leading-[28px]" size="sm">{t3}</TextDisplay>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== authUrl) {
    t5 = <CenterAligned className="self-center rounded-xl bg-white p-3"><QRCodeSVG size={140} value={authUrl} /></CenterAligned>;
    $[7] = authUrl;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t) {
    t6 = t("cantScanCopyKey");
    $[9] = t;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t6) {
    t7 = <TextBody className="text-center" color="inherit" size="sm">{t6}</TextBody>;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== copied) {
    t8 = copied ? <Check size={14} /> : <ContentCopy size={14} />;
    $[13] = copied;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t7 || $[16] !== t8) {
    t9 = <Flex className="items-center gap-1 text-secondary hover:text-text-secondary/80 focus:text-text-secondary/80 active:text-text-secondary/60">{t7}{t8}</Flex>;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== copied || $[19] !== onCopy || $[20] !== t9) {
    t10 = <UnstyledButton disabled={copied} onClick={onCopy}>{t9}</UnstyledButton>;
    $[18] = copied;
    $[19] = onCopy;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10 || $[23] !== t5) {
    t11 = <CenterAligned className="gap-4">{t5}{t10}</CenterAligned>;
    $[22] = t10;
    $[23] = t5;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== code) {
    t12 = <AuthCode autoFocus={true} onChange={setCode} onComplete={onSubmit} value={code} />;
    $[25] = code;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== t) {
    t13 = t("enterCodeFromApp");
    $[27] = t;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== t13) {
    t14 = <TextBody className="text-center" color="text-secondary" size="sm">{t13}</TextBody>;
    $[29] = t13;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== t12 || $[32] !== t14) {
    t15 = <CenterAligned className="gap-4">{t12}{t14}</CenterAligned>;
    $[31] = t12;
    $[32] = t14;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <PasteFromClipboardButton className="mt-8 md:hidden" onPaste={onSubmit} />;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  let t17;
  if ($[35] !== t11 || $[36] !== t15 || $[37] !== t4) {
    t17 = <FlexColumn className="gap-8 pt-12 pb-6">{t4}{t11}{t15}{t16}</FlexColumn>;
    $[35] = t11;
    $[36] = t15;
    $[37] = t4;
    $[38] = t17;
  } else {
    t17 = $[38];
  }
  let t18;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <ModalBackButton onBack={MfaEnrollmentActions.onBack} />;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  let t19;
  if ($[40] !== t17) {
    t19 = <>{t17}{t18}</>;
    $[40] = t17;
    $[41] = t19;
  } else {
    t19 = $[41];
  }
  return t19;
};
export const MfaEnrollment = () => {
  const $ = _c(8);
  const {
    step,
    submitting
  } = useSnapshot(MfaEnrollmentState);
  const {
    mfaMethods,
    loading
  } = useMfaMethods();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useEffect(_temp5, t0);
  if (submitting || loading) {
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <CenterAligned className="h-[400px]"><Spinner /></CenterAligned>;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  switch (step.id) {
    case "select-enrollment-option":
      {
        let t1;
        if ($[2] !== mfaMethods) {
          t1 = <SelectEnrollmentOption enrolledMfaMethods={mfaMethods} />;
          $[2] = mfaMethods;
          $[3] = t1;
        } else {
          t1 = $[3];
        }
        return t1;
      }
    case "enroll-sms":
      {
        let t1;
        if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <EnrollSms />;
          $[4] = t1;
        } else {
          t1 = $[4];
        }
        return t1;
      }
    case "enroll-totp":
      {
        let t1;
        if ($[5] !== step.authUrl || $[6] !== step.secret) {
          t1 = <EnrollTotp authUrl={step.authUrl} secret={step.secret} />;
          $[5] = step.authUrl;
          $[6] = step.secret;
          $[7] = t1;
        } else {
          t1 = $[7];
        }
        return t1;
      }
  }
};
async function _temp() {
  return await MfaEnrollmentActions.selectEnrollmentOption("sms");
}
async function _temp2() {
  return await MfaEnrollmentActions.selectEnrollmentOption("totp");
}
function _temp3() {
  return new Date();
}
function _temp4() {
  MfaEnrollmentActions.setSubmissionError(undefined);
}
function _temp5() {
  return MfaEnrollmentActions.reset;
}